export type fontPair = {

    primary: string,
    secondary: string,
}


export const fontPairs: fontPair[] = [

    {primary:"Oswald",              secondary:"Source Sans Pro"},
    {primary:"Montserrat",          secondary:"Hind"},
    {primary:"Quicksand",           secondary:"Nunito Sans"},
    {primary:"Playfair Display",    secondary:"Lato"},
    {primary:"Be Vietnam",          secondary:"Roboto"},
    {primary:"Neuton",              secondary:"Noto Serif"},
    {primary:"Della Respira",       secondary:"Open Sans"},
    {primary:"Bitter",              secondary:"DM Sans"},


]